export default "__VITE_ASSET___Jm2htrn__"